/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.data.repositoryImpl.notification

import kotlinx.coroutines.flow.StateFlow
import studio.oddpods.cauce.core.data.repository.notification.NotificationSettingsRepository
import studio.oddpods.cauce.core.datastore.NotificationPreferencesRepository
import studio.oddpods.cauce.core.model.notification.NotificationPreferences

class NotificationSettingsRepositoryImpl(
    private val preferencesRepository: NotificationPreferencesRepository,
) : NotificationSettingsRepository {

    override val preferences: StateFlow<NotificationPreferences>
        get() = preferencesRepository.preferences

    override suspend fun setSessionRemindersEnabled(enabled: Boolean) {
        preferencesRepository.update { it.copy(sessionRemindersEnabled = enabled) }
    }

    override suspend fun setPaymentRemindersEnabled(enabled: Boolean) {
        preferencesRepository.update { it.copy(paymentRemindersEnabled = enabled) }
    }

    override suspend fun setSessionAdvanceMinutes(minutes: Int) {
        preferencesRepository.update { it.copy(sessionAdvanceMinutes = minutes) }
    }

    override suspend fun setPaymentSchedule(dayOfWeek: Int, hour: Int, minute: Int) {
        preferencesRepository.update {
            it.copy(
                paymentReminderDayOfWeek = dayOfWeek,
                paymentReminderHour = hour,
                paymentReminderMinute = minute,
            )
        }
    }

    override suspend fun setPermissionRequested(requested: Boolean) {
        preferencesRepository.update { it.copy(permissionRequested = requested) }
    }
}
